import * as React from 'react';
import AggregatedSeats from './Seats/Seats';
import AggregatedBaggage from './Baggage/Baggage';
import AggregatedMeal from './Meal/Meal';
import AggregatedAnimal from './Baggage/Animal';
import AggregatedBaggageDelivery from './Baggage/BaggageDelivery';
import AggregatedAeroexpress from './Aeroexpress/Aeroexpress';
import AggregatedBusiness from './Vip/Business';
import AggregatedLoyalty from './Misc/Loyalty';
import { Insurance } from '../../../../../CheckoutAdditionalService/components';
import EveryPortLounge from '../../../../../CheckoutAdditionalService/components/EveryPortLounge/Lounge/EveryPortLounge';
import { NASProductCategory, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import FastTrack from '../../../../../CheckoutAdditionalService/components/EveryPortLounge/FastTrack/FastTrack';
import Vip from '../../../../../CheckoutAdditionalService/components/EveryPortLounge/Vip/Vip';
import MeetAndGreet from '../../../../../CheckoutAdditionalService/components/EveryPortLounge/MeetAndGreet/MeetAndGreet';
import EveryTravel from '../../../../../CheckoutAdditionalService/components/EveryTravel/EveryTravel';
import OrderInsuranceBlockSlotUpsale from '../../OrderInsuranceBlockSlot/OrderInsuranceBlockSlot.upsale';
const ServicesFactory = ({ service, segmentId, hideCard }) => {
    switch (service.type) {
        case OrderAdditionalServiceGdsServiceServiceType.Seat:
            return React.createElement(AggregatedSeats, { segmentId: segmentId, service: service, hideCard: hideCard });
        case OrderAdditionalServiceGdsServiceServiceType.Baggage:
            return React.createElement(AggregatedBaggage, { segmentId: segmentId, service: service, hideCard: hideCard });
        case OrderAdditionalServiceGdsServiceServiceType.Meal:
            return React.createElement(AggregatedMeal, { segmentId: segmentId, service: service, hideCard: hideCard });
        case 'transfer':
            return React.createElement(AggregatedAeroexpress, { segmentId: segmentId, service: service });
        case 'insurance':
            return (React.createElement(Insurance, { insurancePrograms: service.services, aggregationMode: true }));
        case 'insuranceGroups':
            return React.createElement(OrderInsuranceBlockSlotUpsale, { aggregatorMode: true });
        case NASProductCategory.lounge:
            return React.createElement(EveryPortLounge, { segmentId: segmentId, service: service });
        case NASProductCategory.fast_track:
            return React.createElement(FastTrack, { service: service, segmentId: segmentId });
        case NASProductCategory.vip:
            return React.createElement(Vip, { service: service, segmentId: segmentId });
        case NASProductCategory.meet_and_greet:
            return React.createElement(MeetAndGreet, { service: service, segmentId: segmentId });
        case 'everyTravel':
            return React.createElement(EveryTravel, { service: service });
        case 'baggageDelivery':
            return React.createElement(AggregatedBaggageDelivery, null);
        case 'animal':
            return React.createElement(AggregatedAnimal, null);
        case OrderAdditionalServiceGdsServiceServiceType.BusinessLounge:
            return React.createElement(AggregatedBusiness, null);
        case 'loyalty':
            return React.createElement(AggregatedLoyalty, null);
        default:
            return null;
    }
};
export default ServicesFactory;
